import { ECasinoGameMode, ECasinoGameViewOrder } from 'interfaces/casino-data';
import { ActionType } from 'interfaces/generic';
import {
  NewCasinoCategory,
  NewCasinoGame,
  NewCasinoGamesFetchingParams
} from 'interfaces/new-casino';
import { CasinoGamesConfigs } from 'newelements/Casino/Games/__partials/providers/CasinoGamesConfigsContext';
import { NewCasinoActionTypes } from 'store/action-types/new-casino';

export const setCasinoOriginalCategories = (
  categories: NewCasinoCategory[]
): ActionType => {
  return {
    type: NewCasinoActionTypes.SET_CASINO_ORIGINAL_CATEGORIES,
    payload: categories
  };
};

export const setEnhancedParams = (
  enhancedParams: Partial<NewCasinoGamesFetchingParams>
): ActionType => {
  return {
    type: NewCasinoActionTypes.SET_ENHANCED_PARAMS,
    payload: enhancedParams
  };
};

export const setTotalCount = (totalCount: string): ActionType => {
  return {
    type: NewCasinoActionTypes.SET_GAMES_TOTAL_COUNT,
    payload: totalCount
  };
};

export const setGamesConfigs = (
  gamesConfigs: Partial<CasinoGamesConfigs>
): ActionType => {
  return {
    type: NewCasinoActionTypes.SET_GAMES_CONFIG,
    payload: gamesConfigs
  };
};

export const setCasinoCustomCategories = (
  categories: NewCasinoCategory[]
): ActionType => {
  return {
    type: NewCasinoActionTypes.SET_CASINO_CUSTOM_CATEGORIES,
    payload: categories
  };
};

export const setCasinoOriginalCategoriesSet = (
  categories: string[]
): ActionType => {
  return {
    type: NewCasinoActionTypes.SET_CASINO_ORIGINAL_CATEGORIES_SET,
    payload: categories
  };
};

export const setCasinoOriginalCategoriesSetLeftSideBar = (
  categories: string[]
): ActionType => {
  return {
    type: NewCasinoActionTypes.SET_CASINO_ORIGINAL_CATEGORIES_SET_LEFT_SIDEBAR,
    payload: categories
  };
};

export const setCategoryProviderIds = (payload: string): ActionType => {
  return {
    type: NewCasinoActionTypes.SET_CASINO_CATEGORY_PROVIDER_IDS,
    payload
  };
};

export const setCanRequestCategoriesNestedData = (
  payload: boolean
): ActionType => {
  return {
    type: NewCasinoActionTypes.SET_CAN_REQUEST_CATEGORIES_NESTED_DATA,
    payload
  };
};

export const setCanRequestProvidersNestedData = (
  payload: boolean
): ActionType => {
  return {
    type: NewCasinoActionTypes.SET_CAN_REQUEST_PROVIDERS_NESTED_DATA,
    payload
  };
};

export const setLastPlayedCatSettings = (payload: {
  lastPlayed: boolean;
  lastPlayedCatType: number;
}): ActionType => {
  return {
    type: NewCasinoActionTypes.SET_LAST_PLAYED_CAT_SETTINGS,
    payload
  };
};

export const setCategoryCustomIds = (catCustomIds: string[]): ActionType => {
  return {
    type: NewCasinoActionTypes.SET_CATEGORIES_CUSTOM_IDS,
    payload: catCustomIds
  };
};

export const addCachedGame = (game: NewCasinoGame): ActionType => {
  return {
    type: NewCasinoActionTypes.ADD_CACHED_GAME,
    payload: game
  };
};

export const addCachedGameId = (id: string): ActionType => {
  return {
    type: NewCasinoActionTypes.ADD_CACHED_GAME_ID,
    payload: id
  };
};

export const setCachedGameActive = (id: string): ActionType => {
  return {
    type: NewCasinoActionTypes.SET_CACHED_GAME_ACTIVE,
    payload: id
  };
};

export const setCachedGameInactive = (id: string): ActionType => {
  return {
    type: NewCasinoActionTypes.SET_CACHED_GAME_INACTIVE,
    payload: id
  };
};

export const setCachedGamesInactive = (excludeId?: string): ActionType => {
  return {
    type: NewCasinoActionTypes.SET_CACHED_GAMES_INACTIVE,
    payload: excludeId
  };
};

export const setCachedGameOrder = (payload: {
  id: NewCasinoGame['extearnal_game_id'];
  order: ECasinoGameViewOrder;
}): ActionType => {
  return {
    type: NewCasinoActionTypes.SET_CACHED_GAME_ORDER,
    payload
  };
};

export const setCachedGameMode = (payload: {
  id: NewCasinoGame['extearnal_game_id'];
  mode: ECasinoGameMode;
}): ActionType => {
  return {
    type: NewCasinoActionTypes.SET_CACHED_GAME_MODE,
    payload
  };
};

export const setMobileActiveCardID = (id: string | null): ActionType => {
  return {
    type: NewCasinoActionTypes.SET_MOBILE_ACTIVE_CARD_ID,
    payload: id
  };
};
